import './bootstrap';


import {createApp, h} from 'vue'
import { createStore } from 'vuex'
import mainStore from '@/plugins/Store';
import TopBar from "@/parts/home/TopBar/TopBar.vue";
import FootBar from "@/parts/FootBar.vue";
import HomePage from "@/pages/HomePage.vue";
const store = createStore(mainStore);

window.$ = $;

const el = document.getElementById('app');
const app = createApp({
    props: ['loggedInUser', 'language'],
    name: "VueApp",
    created() {
        console.log('App created');
        store.commit('setUser', JSON.parse(this.loggedInUser))
        // store.commit('setCart', this.cart)
        store.commit('setLanguage', JSON.parse(this.language))
        const language = JSON.parse(this.language);
        if(language.code === 'ar') {
            store.commit('setHrefPrefix', '')
        }
        // if(this.loggedInUser.id != null)
        //     this.$store.dispatch('getCart')
    }
}, {...el.dataset})
app.use(store);

import i18n from './i18n'
import LoginPage from "@/pages/LoginPage.vue";
import CategoryPage from "@/pages/CategoryPage.vue";
import BecomeAnAuthorPage from "@/pages/BecomeAnAuthorPage.vue";
import ColumnsPage from "@/pages/ColumnsPage.vue";
import profileSettingsPage from "@/pages/ProfileSettingsPage.vue";
import myCommentsPage from "@/pages/MyCommentsPage.vue";
import ArticlePage from "@/pages/ArticlePage.vue";
import searchPage from "@/pages/SearchPage.vue";
import verifyEmail from "@/pages/VerifyEmail.vue";
import AuthorPage from "@/pages/AuthorPage";
import SupportUsPage from "@/pages/SupportUsPage.vue";
import podcastPage from "@/pages/PodcastsPage.vue";
import PodcastPage from "@/pages/PodcastsPage.vue";
import PodcastsPage from "@/pages/PodcastsPage.vue";
import ForgetPasswordPage from "@/pages/ForgetPasswordPage.vue";
import ChangePasswordPage from "@/pages/ChangePasswordPage.vue";
app.use(i18n.create(document.documentElement.lang));

app.component('top-bar', TopBar);
app.component('foot-bar', FootBar);
app.component('home-page', HomePage);
app.component('support-us-page', SupportUsPage)
app.component('login-page', LoginPage);
app.component('forget-password-page', ForgetPasswordPage);
app.component('change-password-page', ChangePasswordPage);
app.component('category-page', CategoryPage);
app.component('article-page', ArticlePage);
app.component('author-page', AuthorPage);
app.component('become-an-author-page', BecomeAnAuthorPage)
app.component('columns-page', ColumnsPage)
app.component('profile-settings-page', profileSettingsPage)
app.component('my-comments-page', myCommentsPage)
app.component('search-page', searchPage)
app.component('verify-email-page', verifyEmail)
app.component('podcasts-page', PodcastsPage)


app.mount(el)
